// extracted by mini-css-extract-plugin
export default {"page":"PageRenderer_page__PV3IY","fadeIn":"PageRenderer_fadeIn__IOpak"};